import React__default from "react";
import { AnalyticsContext } from "../../helpers/analytics/analytics-provider/analytics-provider.mjs";
import { ToastContext } from "./toast-context.mjs";
const useToast = () => {
  const { setToastData } = React__default.useContext(ToastContext);
  const { event, page, group } = React__default.useContext(AnalyticsContext);
  const success = React__default.useCallback(
    (content) => {
      setToastData({
        content,
        type: "success",
        analyticsData: {
          event,
          page,
          group
        }
      });
    },
    [setToastData, event, page, group]
  );
  const info = React__default.useCallback(
    (content) => {
      setToastData({
        content,
        type: "info",
        analyticsData: {
          event,
          page,
          group
        }
      });
    },
    [setToastData, event, page, group]
  );
  const attention = React__default.useCallback(
    (content) => {
      setToastData({
        content,
        type: "attention",
        analyticsData: {
          event,
          page,
          group
        }
      });
    },
    [setToastData, event, page, group]
  );
  const error = React__default.useCallback(
    (content) => {
      setToastData({
        content,
        type: "error",
        analyticsData: {
          event,
          page,
          group
        }
      });
    },
    [setToastData, event, page, group]
  );
  return React__default.useMemo(() => ({ success, info, attention, error }), [success, info, attention, error]);
};
export {
  useToast
};
